<div class="Dialog" mat-dialog-content>
  <div>
    <p>Only {{ maxVisibilityCount() }} visible rings are allowed at one time.</p>
  </div>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close] class="ThemeColorAccent">Ok</button>
  </mat-dialog-actions>
</div>